const DETAILS_PREFIX = '@DETAILS';

export const FETCH = `${DETAILS_PREFIX}/FETCH`;
export const FETCH_SUCCESS = `${DETAILS_PREFIX}/FETCH_SUCCESS`;
export const FETCH_ERROR = `${DETAILS_PREFIX}/FETCH_ERROR`;

export const SAVE_VIDEO_PROGRESS = `${DETAILS_PREFIX}/SAVE_VIDEO_PROGRESS`;
export const RESET_VIDEO_PROGRESS = `${DETAILS_PREFIX}/RESET_VIDEO_PROGRESS`;

export const FETCH_SEASONS = `${DETAILS_PREFIX}/FETCH_SEASONS`;
export const FETCH_SEASONS_SUCCESS = `${DETAILS_PREFIX}/FETCH_SEASONS_SUCCESS`;
export const FETCH_SEASONS_ERROR = `${DETAILS_PREFIX}/FETCH_SEASONS_ERROR`;

export const FETCH_EPISODES = `${DETAILS_PREFIX}/FETCH_EPISODES`;
export const FETCH_EPISODES_SUCCESS = `${DETAILS_PREFIX}/FETCH_EPISODES_SUCCESS`;
export const FETCH_EPISODES_ERROR = `${DETAILS_PREFIX}/FETCH_EPISODES_ERROR`;

export const FETCH_EPISODES_BATCH = `${DETAILS_PREFIX}/FETCH_EPISODES_BATCH`;
export const FETCH_EPISODES_BATCH_SUCCESS = `${DETAILS_PREFIX}/FETCH_EPISODES_BATCH_SUCCESS`;
export const FETCH_EPISODES_BATCH_ERROR = `${DETAILS_PREFIX}/FETCH_EPISODES_BATCH_ERROR`;

export const FETCH_RECOMMENDATIONS = `${DETAILS_PREFIX}/FETCH_RECOMMENDATIONS`;
export const FETCH_RECOMMENDATIONS_SUCCESS = `${DETAILS_PREFIX}/FETCH_RECOMMENDATIONS_SUCCESS`;
export const FETCH_RECOMMENDATIONS_ERROR = `${DETAILS_PREFIX}/FETCH_RECOMMENDATIONS_ERROR`;

export const FETCH_EXTRA_RECOMMENDATIONS = `${DETAILS_PREFIX}/FETCH_EXTRA_RECOMMENDATIONS`;
export const FETCH_EXTRA_RECOMMENDATIONS_SUCCESS = `${DETAILS_PREFIX}/FETCH_EXTRA_RECOMMENDATIONS_SUCCESS`;
export const FETCH_EXTRA_RECOMMENDATIONS_ERROR = `${DETAILS_PREFIX}/FETCH_EXTRA_RECOMMENDATIONS_ERROR`;

export const FETCH_RELATED_ITEMS = `${DETAILS_PREFIX}/FETCH_RELATED_ITEMS`;
export const FETCH_RELATED_ITEMS_SUCCESS = `${DETAILS_PREFIX}/FETCH_RELATED_ITEMS_SUCCESS`;
export const FETCH_RELATED_ITEMS_ERROR = `${DETAILS_PREFIX}/FETCH_RELATED_ITEMS_ERROR`;

export const FETCH_EXTRA_RELATED_ITEMS = `${DETAILS_PREFIX}/FETCH_EXTRA_RELATED_ITEMS`;
export const FETCH_EXTRA_RELATED_ITEMS_SUCCESS = `${DETAILS_PREFIX}/FETCH_EXTRA_RELATED_ITEMS_SUCCESS`;
export const FETCH_EXTRA_RELATED_ITEMS_ERROR = `${DETAILS_PREFIX}/FETCH_EXTRA_RELATED_ITEMS_ERROR`;

export const TOGGLE_WATCHLIST = `${DETAILS_PREFIX}/TOGGLE_WATCHLIST`;
export const TOGGLE_WATCHLIST_SUCCESS = `${DETAILS_PREFIX}/TOGGLE_WATCHLIST_SUCCESS`;
export const TOGGLE_WATCHLIST_ERROR = `${DETAILS_PREFIX}/TOGGLE_WATCHLIST_ERROR`;

export const BUY_DETAILS_ITEM = `${DETAILS_PREFIX}/BUY_DETAILS_ITEM`;
export const BUY_DETAILS_ITEM_SUCCESS = `${DETAILS_PREFIX}/BUY_DETAILS_ITEM_SUCCESS`;
export const BUY_DETAILS_ITEM_ERROR = `${DETAILS_PREFIX}/BUY_DETAILS_ITEM_ERROR`;

export const UPDATE_DETAILS = `${DETAILS_PREFIX}/UPDATE_DETAILS`;

export const RESET_ALL_DATA = `${DETAILS_PREFIX}/RESET_ALL_DATA`;
